import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$userInfo$newestAp, _vm$userInfo;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "user-info-box"
  }, [_c("div", {
    staticClass: "user-box"
  }, [_c("img", {
    staticClass: "user-cover",
    attrs: {
      src: _vm.userInfo.avatar,
      alt: ""
    }
  }), _c("div", {
    staticClass: "user-info"
  }, [_c("div", [_c("div", {
    staticClass: "wlc-f-c"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.name))]), _vm.createTime ? _c("el-tag", {
    attrs: {
      type: "info",
      size: "small"
    }
  }, [_vm._v(_vm._s(_vm.createTime) + " 注册 ")]) : _vm._e()], 1), _c("div", {
    staticClass: "app-info"
  }, [_vm._v(" " + _vm._s((_vm$userInfo$newestAp = _vm.userInfo.newestAppInfo) === null || _vm$userInfo$newestAp === void 0 ? void 0 : _vm$userInfo$newestAp.phoneBrand) + " ")])]), _c("div", {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c("div", {
    staticClass: "tag-list"
  }, [_vm._l((_vm$userInfo = _vm.userInfo) === null || _vm$userInfo === void 0 ? void 0 : _vm$userInfo.userCities, function (i, index) {
    return _c("el-tag", {
      key: index,
      attrs: {
        type: "info",
        size: "small"
      }
    }, [_vm._v(_vm._s(i.name) + " ")]);
  }), _c("el-tag", {
    attrs: {
      type: "info",
      size: "small"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.gender == 2 ? "女" : "男") + " ")]), _c("el-tag", {
    attrs: {
      type: "info",
      size: "small"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.occupation) + " ")]), _vm.userInfo.remark ? _c("el-tag", {
    attrs: {
      type: "info",
      size: "small"
    }
  }, [_vm._v(" 备注：" + _vm._s(_vm.userInfo.remark) + " ")]) : _vm._e()], 2), _c("div", {
    staticClass: "category-list"
  }, _vm._l(_vm.userInfo.postCategories, function (i, index) {
    return _c("el-tag", {
      key: index,
      attrs: {
        size: "small"
      }
    }, [_vm._v(_vm._s(i.name) + " ")]);
  }), 1)])])]), _c("wlc-radar-chart", {
    attrs: {
      id: _vm.userInfo.id
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };